<div class="general-report">
  <table class="general-table table table-bordered">
    <tr class="general-table__header">
      <td colspan="2">
        {{ "forms.common.generalReport" | translate }}
      </td>
      <td colspan="1">
        {{ "forms.common.evaluation" | translate }}
      </td>
    </tr>

    <tr *ngFor="let criterion of criterions | sort">
      <td colspan="2">
        {{ criterion | propertyLocalized : ["nameAr", "nameEn"] | async }}
      </td>
      <td width="35%">{{ criterion.totalEvaluation || 0 }}</td>
    </tr>
    
	<tr>
      <td colspan="2">
        {{ "forms.common.total" | translate }}
      </td>
      <td width="35%">{{ evaluations }}</td>
    </tr>
  </table>
</div>
